<template>
  <div>
    <vx-card>
      <ListPermissoes :subjectPermission="subjectPermission"></ListPermissoes>
    </vx-card>
  </div>
</template>

<script>
import ListPermissoes from "./../../lists/ListPermissoes";

export default {
  data() {
    return {
      subjectPermission: "Permissões",
    };
  },
  methods: {},
  components: {
    ListPermissoes,
  },
};
</script>
